import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Shared modules
import { DesignSystemModule } from '../designSystem/design-system.module';

// MU
import { LoginSharedComponent } from 'src/app/components/shared/sharedModules/auth/login-shared/login-shared.component';
import { AuthLoginCreateFormComponent } from './form/auth-login-create-form/auth-login-create-form.component';
import { ValidatorModule } from '../validator/validator.module';


// Primeng
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedModule } from '../../sharedComponents/shared.module';
import { AuthRoutingModule } from 'src/app/components/auth/auth-routing.module';
import { AuthLoginTermsModalComponent } from './form/auth-login-terms-modal/auth-login-terms-modal.component';
import { MuModalLoginComponent } from './mu-modal-login/mu-modal-login.component';
import { DialogModule } from 'primeng/dialog';
import {PasswordModule} from 'primeng/password';



@NgModule({
  declarations: [
    LoginSharedComponent,
    AuthLoginCreateFormComponent,
    AuthLoginTermsModalComponent,
    MuModalLoginComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({}),
    DesignSystemModule,
    ValidatorModule,
    SharedModule,
    ButtonModule,
    CheckboxModule,
    AuthRoutingModule,
    DialogModule,
    PasswordModule

  ],
  exports: [LoginSharedComponent, MuModalLoginComponent]
})
export class SharedAuthModule { }
